import Aside from "../../components/aside";
import {
  useNavigate,
  useParams
} from "react-router-dom";
import PlatformManage from "../platform_manage";
import React, {
  useEffect,
  useRef,
  useState
} from "react";
import styled from "styled-components";
import Modal from "../../components/modal/Modal";
import {
  useAtom,
  useSetAtom
} from "jotai";
import {useResetAtom} from "jotai/utils";
import {
  tokenResultAtom
} from "../login/entity/Common";
import {
  logOutAdmin,
  logOutUser,
  refresh,
  refreshAdmin
} from "../../services/auth/AuthAxios";
import Campaign from "../campaign";
import Settings from "../settings";
import {RESET} from "jotai/utils";
import Reports from "../reports";
import PlatformUserDetail from "../platform_manage/UserDetail";
import PlatformAdminDetail from "../platform_manage/AdminDetail";
import PaymentManageUser from "../platform_manage/PaymentManageUser";
import DashBoard from "../dash_board";
import {
  BoardContainer,
  TitleContainer
} from "../../assets/GlobalStyles";
import Navigator from "../../components/common/Navigator";
import {
  CampaignLookOver
} from "../campaign/steps/CampaignLookOver";
import {
  CampaignTwo
} from "../campaign/steps/CampaignTwo";
import {
  FormProvider,
  useForm
} from "react-hook-form";
import {
  CampaignThree
} from "../campaign/steps/CampaignThree";
import {
  CampaignFour
} from "../campaign/steps/CampaignFour";
import {
  stepCampaignAtom
} from "../campaign/entity";
import {
  retrieveUserPoint
} from "./entity/UserPoint";
import {
  searchConditionAtom
} from "../dash_board/entity/Common";
import {
  retrieveUserPointRequest
} from "../../services/payment/user/RetrieveUserPointAxios";
import Customer from "../customer";

function Layout() {
  const params = useParams();
  const navigate = useNavigate();
  const methods = useForm();

  const [
    tokenUserInfo,
    setTokenUserInfo
  ] = useAtom(tokenResultAtom);

  const [
    ,
    setUserPoint
  ] = useAtom(retrieveUserPoint);

  const setStepCampaign =
      useSetAtom(stepCampaignAtom);

  const resetInfo =
      useResetAtom(searchConditionAtom);

  const setTokenResult =
      useSetAtom(tokenResultAtom);

  const userMenuRef = useRef(null);

  const [
    isUserMenuOpen,
    setIsUserMenuOpen
  ] = useState(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (tokenUserInfo.role !== "") {
      return;
    }

    refreshAdmin()
    .then(response => {
      if (!response) {
        navigate("/");
        return;
      }

      const {
        data,
        statusCode
      } = response;

      if (statusCode === 200) {
        const entity = data;

        setTokenUserInfo({
          id: entity.email,
          role: entity.role,
          name: entity.name,
          accessToken:
          entity.token.accessToken
        });

        return;
      }

      refresh().then(userResponse => {
        if (!userResponse) {
          navigate("/");
          return;
        }

        const {
          data: userData,
          status
        } = userResponse;

        if (status === 200) {
          const entity =
              userData.data;

          setTokenUserInfo({
            id: entity.id,
            username:
            entity.username,
            role: entity.role,
            name: entity.name,
            accessToken:
            entity.token.accessToken
          });

          return;
        }

        navigate("/");
      });
    })
    .catch(error => {
      console.error(
          "사용자 인증 정보 갱신 실패:",
          error
      );

      navigate("/");
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
        ![
          "dashboard",
          "campaignLookOver",
          "campaignTwo",
          "campaignThree",
          "campaignFour"
        ].includes(params.id)
    ) {
      resetInfo();
    }

    if (params.id !== "campaign") {
      setStepCampaign({
        steps: null
      });
    }

    setIsUserMenuOpen(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  useEffect(() => {
    if (
        tokenUserInfo.role !==
        "NORMAL"
    ) {
      return;
    }

    const loadUserPoint =
        async () => {
          try {
            const response =
                await retrieveUserPointRequest(
                    tokenUserInfo.id
                );

            setUserPoint(
                response?.availablePoint ?? 0
            );
          } catch (error) {
            console.error(
                "광고비 잔액 조회 실패:",
                error
            );
          }
        };

    if (tokenUserInfo.id) {
      loadUserPoint();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tokenUserInfo.id,
    tokenUserInfo.role
  ]);

  useEffect(() => {
    if (!isUserMenuOpen) {
      return undefined;
    }

    const handleDocumentClick =
        event => {
          if (
              userMenuRef.current &&
              !userMenuRef.current.contains(
                  event.target
              )
          ) {
            setIsUserMenuOpen(false);
          }
        };

    const handleEscape =
        event => {
          if (event.key === "Escape") {
            setIsUserMenuOpen(false);
          }
        };

    document.addEventListener(
        "mousedown",
        handleDocumentClick
    );

    document.addEventListener(
        "keydown",
        handleEscape
    );

    return () => {
      document.removeEventListener(
          "mousedown",
          handleDocumentClick
      );

      document.removeEventListener(
          "keydown",
          handleEscape
      );
    };
  }, [isUserMenuOpen]);

  const myPage = () => {
    setIsUserMenuOpen(false);

    if (
        tokenUserInfo.role ===
        "NORMAL"
    ) {
      navigate(
          "/board/myPageUser",
          {
            state: {
              id: tokenUserInfo.id
            }
          }
      );

      return;
    }

    navigate(
        "/board/myPageAdmin",
        {
          state: {
            id: tokenUserInfo.id
          }
        }
    );
  };

  const logOut = async () => {
    setIsUserMenuOpen(false);

    const userInfo = {
      accessToken:
      tokenUserInfo.accessToken,
      refreshToken:
          localStorage.getItem(
              "refreshToken"
          )
    };

    try {
      if (
          tokenUserInfo.role ===
          "NORMAL"
      ) {
        await logOutUser(userInfo);
      } else {
        await logOutAdmin(userInfo);
      }
    } catch (error) {
      console.error(
          "로그아웃 요청 실패:",
          error
      );
    } finally {
      setTokenResult(RESET);
      localStorage.removeItem(
          "refreshToken"
      );
      window.location.replace("/");
    }
  };

  const payment = () => {
    navigate(
        "/board/paymentManageUser"
    );
  };

  const displayName =
      tokenUserInfo?.name ||
      tokenUserInfo?.username ||
      "사용자";

  const userInitial =
      displayName
      .trim()
      .charAt(0)
      .toUpperCase() || "U";

  const roleLabel =
      tokenUserInfo.role === "NORMAL"
          ? "광고주"
          : "관리자";

  const isMyPageActive = [
    "myPageAdmin",
    "myPageUser"
  ].includes(params.id);

  return (
      <LayoutContainer id="container">
        <Aside
            mobileOpen={isMobileMenuOpen}
            onNavigate={() => setIsMobileMenuOpen(false)}
        />

        <MobileOverlay
            $open={isMobileMenuOpen}
            aria-hidden="true"
            onClick={() => setIsMobileMenuOpen(false)}
        />

        <BoardBody>
          <BoardHeader>
            <HeaderInner>
              <HeaderLeftArea>
                <MobileMenuButton
                    type="button"
                    aria-label="전체 메뉴 열기"
                    aria-expanded={isMobileMenuOpen}
                    onClick={() => setIsMobileMenuOpen(true)}
                >
                  <span />
                  <span />
                  <span />
                </MobileMenuButton>

                <Navigator global />
              </HeaderLeftArea>

              <HeaderRightArea>
                <NotificationButton type="button" aria-label="알림 확인">
                  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6v-5a7 7 0 0 0-5.5-6.84V3a1.5 1.5 0 0 0-3 0v1.16A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Zm-12 .83V11a5 5 0 0 1 10 0v5.83l.17.17H6.83L7 16.83Z"/>
                  </svg>
                  <NotificationDot />
                </NotificationButton>

                <UserMenuContainer
                    ref={userMenuRef}
                >
                  <UserMenuButton
                      type="button"
                      $open={isUserMenuOpen}
                      $active={isMyPageActive}
                      aria-expanded={
                        isUserMenuOpen
                      }
                      aria-haspopup="menu"
                      onClick={() =>
                          setIsUserMenuOpen(
                              prev => !prev
                          )
                      }
                  >
                    <UserAvatar>
                      {userInitial}
                    </UserAvatar>

                    <UserInfo>
                      <UserName>
                        {displayName}
                      </UserName>

                      <UserRole>
                        {roleLabel}
                      </UserRole>
                    </UserInfo>

                    <ChevronIcon
                        $open={isUserMenuOpen}
                        aria-hidden="true"
                    >
                      <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                      >
                        <path
                            fill="currentColor"
                            d="m7 10 5 5 5-5H7Z"
                        />
                      </svg>
                    </ChevronIcon>
                  </UserMenuButton>

                  {isUserMenuOpen && (
                      <UserDropdown
                          role="menu"
                      >
                        <DropdownUserSummary>
                          <DropdownAvatar>
                            {userInitial}
                          </DropdownAvatar>

                          <DropdownUserText>
                            <DropdownUserName>
                              {displayName}
                            </DropdownUserName>

                            <DropdownUserId>
                              {tokenUserInfo
                                      ?.username ||
                                  tokenUserInfo
                                      ?.id ||
                                  roleLabel}
                            </DropdownUserId>
                          </DropdownUserText>
                        </DropdownUserSummary>

                        <DropdownDivider />

                        <DropdownMenuButton
                            type="button"
                            role="menuitem"
                            $active={
                              isMyPageActive
                            }
                            onClick={myPage}
                        >
                          <MenuButtonIcon
                              aria-hidden="true"
                          >
                            <svg
                                width="17"
                                height="17"
                                viewBox="0 0 24 24"
                            >
                              <path
                                  fill="currentColor"
                                  d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 10c-4.42 0-8 2.24-8 5v3h16v-3c0-2.76-3.58-5-8-5Zm-6 5c0-1.1 2.28-3 6-3s6 1.9 6 3v1H6v-1Z"
                              />
                            </svg>
                          </MenuButtonIcon>

                          <MenuButtonText>
                            <strong>
                              마이페이지
                            </strong>
                            <span>
                          내 정보 및 계정 설정
                        </span>
                          </MenuButtonText>

                          <MenuArrow
                              aria-hidden="true"
                          >
                            ›
                          </MenuArrow>
                        </DropdownMenuButton>

                        {tokenUserInfo.role ===
                            "NORMAL" && (
                                <DropdownMenuButton
                                    type="button"
                                    role="menuitem"
                                    $active={
                                        params.id ===
                                        "paymentManageUser"
                                    }
                                    onClick={() => {
                                      setIsUserMenuOpen(
                                          false
                                      );
                                      payment();
                                    }}
                                >
                                  <MenuButtonIcon
                                      aria-hidden="true"
                                  >
                                    <svg
                                        width="17"
                                        height="17"
                                        viewBox="0 0 24 24"
                                    >
                                      <path
                                          fill="currentColor"
                                          d="M21 7H3V5h18v2Zm0 2v10H3V9h18Zm-2 3H5v5h14v-5Zm-8 1h6v2h-6v-2Z"
                                      />
                                    </svg>
                                  </MenuButtonIcon>

                                  <MenuButtonText>
                                    <strong>
                                      광고비 관리
                                    </strong>
                                    <span>
                            잔액 및 충전 내역
                          </span>
                                  </MenuButtonText>

                                  <MenuArrow
                                      aria-hidden="true"
                                  >
                                    ›
                                  </MenuArrow>
                                </DropdownMenuButton>
                            )}

                        <DropdownDivider />

                        <LogoutButton
                            type="button"
                            role="menuitem"
                            onClick={logOut}
                        >
                          <MenuButtonIcon
                              aria-hidden="true"
                          >
                            <svg
                                width="17"
                                height="17"
                                viewBox="0 0 24 24"
                            >
                              <path
                                  fill="currentColor"
                                  d="M10 17v-3H3v-4h7V7l5 5-5 5Zm2-15h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-7v-2h7V4h-7V2Z"
                              />
                            </svg>
                          </MenuButtonIcon>

                          <MenuButtonText>
                            <strong>
                              로그아웃
                            </strong>
                            <span>
                          현재 계정에서 로그아웃
                        </span>
                          </MenuButtonText>
                        </LogoutButton>
                      </UserDropdown>
                  )}
                </UserMenuContainer>
              </HeaderRightArea>
            </HeaderInner>
          </BoardHeader>

          <BoardContent>
            {params.id ===
                "dashboard" && (
                    <DashBoard />
                )}

            {params.id ===
                "campaignLookOver" && (
                    <main>
                      <BoardContainer>
                        <FormProvider
                            {...methods}
                        >
                          <CampaignLookOver />
                        </FormProvider>
                      </BoardContainer>
                    </main>
                )}

            {params.id ===
                "campaignTwo" && (
                    <main>
                      <BoardContainer>
                        <FormProvider
                            {...methods}
                        >
                          <CampaignTwo />
                        </FormProvider>
                      </BoardContainer>
                    </main>
                )}

            {params.id ===
                "campaignThree" && (
                    <main>
                      <BoardContainer>
                        <FormProvider
                            {...methods}
                        >
                          <CampaignThree />
                        </FormProvider>
                      </BoardContainer>
                    </main>
                )}

            {params.id ===
                "campaignFour" && (
                    <main>
                      <BoardContainer>
                        <FormProvider
                            {...methods}
                        >
                          <CampaignFour />
                        </FormProvider>
                      </BoardContainer>
                    </main>
                )}

            {[
              "campaign",
              "manageCreative",
              "manageCreativeDetail",
              "bannerCreative",
              "audioCreative"
            ].includes(params.id) && (
                <Campaign />
            )}

            {[
              "reportsPeriod",
              "reportsPeriodHour",
              "reportsAdver",
              "reportsCampaign",
              "reports",
              "customReports"
            ].includes(params.id) && (
                <Reports />
            )}

            {[
              "notice",
              "noticeDetail",
              "inquiry",
              "inquiryDetail"
            ].includes(params.id) && (
                <Customer />
            )}

            {[
              "budgetTime",
              "budgetTimeDetail",
              "budgetTimeList",
              "settings",
              "settingsDetail",
              "budgetEvent",
              "budgetEventDetail"
            ].includes(params.id) && (
                <Settings />
            )}

            {[
              "platform",
              "platformDetail",
              "platformAdmin",
              "categoryManage",
              "productManage",
              "conversionManage",
              "historyCampaignManage",
              "historyPriceManage",
              "historyEventManage",
              "historyTimeManage",
              "historyCampaignDetail",
              "historyPriceDetail",
              "historyEventDetail",
              "historyTimeDetail",
              "paymentManage",
              "advertisingPayments",
              "regionManage",
              "platformTerm",
              "platformTermDetail"
            ].includes(params.id) && (
                <PlatformManage />
            )}

            {params.id ===
                "paymentManageUser" && (
                    <PaymentManageUser />
                )}

            {params.id ===
                "myPageUser" && (
                    <main>
                      <BoardContainer>
                        <TitleContainer>
                          <h1>
                            나의 정보
                          </h1>
                        </TitleContainer>

                        <PlatformUserDetail />
                      </BoardContainer>
                    </main>
                )}

            {params.id ===
                "myPageAdmin" && (
                    <PlatformAdminDetail />
                )}
          </BoardContent>
        </BoardBody>

        <Modal />
      </LayoutContainer>
  );
}

export default Layout;

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #f5f6f8;
`;

const BoardBody = styled.div`
  width: 0;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 0;
  overflow-x: hidden;
  overflow-y: auto;
`;

const BoardHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #e8eaed;
  background-color: rgba(255, 255, 255, .96);
  box-shadow: 0 2px 10px rgba(31, 41, 55, .025);
  backdrop-filter: blur(8px);
`;

const HeaderInner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px;

  @media (max-width: 700px) {
    padding: 0 14px;
  }
`;

const HeaderRightArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;

const HeaderLeftArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
  overflow: hidden;
`;

const MobileMenuButton = styled.button`
  display: none;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  border: 1px solid #e5e8eb;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  span { width: 15px; height: 1.5px; border-radius: 2px; background: #4b5563; }
  &:hover { border-color: #f1d4c2; background: #fffaf6; }
  @media (max-width: 960px) { display: inline-flex; }
`;

const NotificationButton = styled.button`
  position: relative;
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e5e8eb;
  border-radius: 50%;
  background: #fff;
  color: #5f6770;
  cursor: pointer;
  &:hover { border-color: #f1d4c2; background: #fffaf6; color: #f5811f; }
`;

const NotificationDot = styled.span`
  position: absolute;
  top: 7px;
  right: 7px;
  width: 6px;
  height: 6px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #f5811f;
`;

const MobileOverlay = styled.button`
  position: fixed;
  inset: 0;
  z-index: 210;
  display: ${({$open}) => $open ? "block" : "none"};
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(15, 23, 42, .46);
  cursor: default;
`;

const UserMenuContainer = styled.div`
  position: relative;
`;

const UserMenuButton = styled.button`
  display: flex;
  min-width: 174px;
  min-height: 46px;
  align-items: center;
  gap: 9px;
  padding: 5px 9px 5px 6px;
  border: 1px solid
    ${({$open, $active}) =>
    $open || $active
        ? "#f1d4c2"
        : "#e5e5e5"};
  border-radius: 9px;
  background-color:
    ${({$open, $active}) =>
    $open || $active
        ? "#fffaf6"
        : "#fff"};
  color: #444;
  cursor: pointer;
  text-align: left;

  &:hover {
    border-color: #f1d4c2;
    background-color: #fffaf6;
  }

  &:focus-visible {
    outline: 1px solid #f5811f;
    outline-offset: 2px;
  }

  @media (max-width: 520px) {
    min-width: auto;
    padding-right: 7px;
  }
`;

const UserAvatar = styled.span`
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: 14px;
  font-weight: 800;
`;

const UserInfo = styled.span`
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 2px;

  @media (max-width: 520px) {
    display: none;
  }
`;

const UserName = styled.strong`
  overflow: hidden;
  color: #333;
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const UserRole = styled.span`
  color: #999;
  font-size: 11px;
`;

const ChevronIcon = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: #f5811f;
  transform:
    rotate(
      ${({$open}) =>
    $open
        ? "180deg"
        : "0deg"}
    );
  transition: transform 0.18s ease;
`;

const UserDropdown = styled.div`
  position: absolute;
  top: calc(100% + 9px);
  right: 0;
  z-index: 120;
  width: 246px;
  box-sizing: border-box;
  padding: 8px;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background-color: #fff;
  box-shadow:
    0 14px 38px
    rgba(0, 0, 0, 0.13);
  animation:
    user-dropdown-open
    0.16s ease-out;

  &::before {
    position: absolute;
    top: -6px;
    right: 18px;
    width: 10px;
    height: 10px;
    border-top: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    background-color: #fff;
    content: "";
    transform: rotate(45deg);
  }

  @keyframes user-dropdown-open {
    from {
      opacity: 0;
      transform:
        translateY(-5px)
        scale(0.98);
    }

    to {
      opacity: 1;
      transform:
        translateY(0)
        scale(1);
    }
  }

  @media (max-width: 520px) {
    position: fixed;
    top: 61px;
    right: 12px;
    left: 12px;
    width: auto;

    &::before {
      display: none;
    }
  }
`;

const DropdownUserSummary =
    styled.div`
    display: flex;
    min-height: 58px;
    align-items: center;
    gap: 10px;
    padding: 7px 8px;
  `;

const DropdownAvatar = styled.span`
  display: inline-flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: 15px;
  font-weight: 800;
`;

const DropdownUserText = styled.span`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
`;

const DropdownUserName = styled.strong`
  overflow: hidden;
  color: #333;
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DropdownUserId = styled.span`
  overflow: hidden;
  color: #999;
  font-size: 11px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const DropdownDivider = styled.div`
  height: 1px;
  margin: 5px 4px;
  background-color: #eeeeee;
`;

const DropdownMenuButton =
    styled.button`
    display: grid;
    width: 100%;
    min-height: 50px;
    grid-template-columns:
      30px minmax(0, 1fr) 18px;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border: 0;
    border-radius: 7px;
    background-color:
      ${({$active}) =>
        $active
            ? "#fff4e8"
            : "transparent"};
    color:
      ${({$active}) =>
        $active
            ? "#f5811f"
            : "#555"};
    cursor: pointer;
    text-align: left;

    &:hover {
      background-color: #fffaf6;
      color: #f5811f;
    }
  `;

const LogoutButton = styled(
    DropdownMenuButton
)`
  grid-template-columns:
    30px minmax(0, 1fr);
  color: #777;

  &:hover {
    background-color: #fff3f3;
    color: #d85a5a;
  }
`;

const MenuButtonIcon = styled.span`
  display: inline-flex;
  width: 29px;
  height: 29px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background-color: #f5f5f5;
  color: currentColor;
`;

const MenuButtonText = styled.span`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;

  & strong {
    color: currentColor;
    font-size: 12px;
    font-weight: 700;
  }

  & span {
    color: #999;
    font-size: 10px;
  }
`;

const MenuArrow = styled.span`
  color: #aaa;
  font-size: 19px;
`;

const BoardContent = styled.div`
  min-width: 0;
  min-height: calc(100vh - 56px);
  background: #f5f6f8;
`;
